<template>
  <div class="anz-fc-alert anz-fc-alert-error anz-px-s anz-py-xs anz-mb-s">
    <div class="anz-fc-alert-icon">
      <a-icon width="1em" height="1em" name="exclamation-circle" />
    </div>
    <span class="anz-fc-alert-msg">
      <slot name="title">
        {{ title }}
      </slot>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: 'AError',
  components: { AIcon },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
</script>
